module.exports = __webpack_public_path__ + "static/media/deathBenefit.396fe4c5.svg";